<template>
  <div class="online-payment-section online-payment-section-borderless mx-ni px-i pb-0">
    <div id="checkout-form" class="online-payment-form">
      <div class="online-payment-form-row">
        <div class="online-payment-form-row-start flex-grow-1">
          <label class="online-payment-form-row-start-label">Card Number</label>
          <div class="card-number-frame" />
        </div>
      </div>
      <div class="online-payment-form-row">
        <div class="online-payment-form-row-start">
          <div class="online-payment-form-row-start-date">
            <div class="online-payment-form-row-start-date-field">
              <label class="online-payment-form-row-start-date-field-label">Expiry Date</label>
              <div class="expiry-date-frame" />
            </div>
          </div>
        </div>
        <div class="online-payment-form-row-end">
          <label class="online-payment-form-row-end-label">CCV</label>
          <div class="cvv-frame" />
        </div>
      </div>
      <div class="online-payment-form-row online-payment-form-row-checkout-strip">
        <span class="online-payment-form-row-checkout-strip-image" />
      </div>
    </div>
    <button id="checkoutPayButton" type="button" class="btn btn-primary ihjoz-button ihjoz-button-big-size online-payment-section-pay mb-3">
      <i class="demo-icon icon-lock" />
      <div class="lds-ring payment-spinner">
        <div />
        <div />
        <div />
        <div />
      </div>Pay
    </button>
    <div class="online-payment-section-notice px-i">
      <p>By submitting the order you acknowledge that you agree to the Terms & Conditions of Fawter and the Invoice.</p>
      <p>*Prices are VAT inclusive</p>
    </div>
  </div>
</template>

<script>
import PaymentStore from "./PaymentStore";

var loadCheckoutPayment = function (component, publicKey) {
  var payButton = document.getElementById("checkoutPayButton");
  var form = document.getElementById("form-card");

  var errors = {};
  errors["card-number"] = "Please enter a valid card number";
  errors["expiry-date"] = "Please enter a valid expiry date";
  errors["cvv"] = "Please enter a valid cvv code";

  Frames.init({
    publicKey: publicKey,
    style: {
      base: {
        fontSize: "20px",
        textAlign: "center",
        background: "white",
        borderRadius: "8px",
        color: "#495057",
        boxShadow: "none"
      },
      invalid: {
        color: "#e74b3b"
      },
      placeholder: {
        base: {
          color: "rgb(172, 172, 172)",
          fontFamily: "Monospace"
        }
      }
    },
    localization: {
      cardNumberPlaceholder: "1234 XXXX XXXX 5678",
      expiryMonthPlaceholder: "MM",
      expiryYearPlaceholder: "YY",
      cvvPlaceholder: "CCV"
    }
  });

  Frames.addEventHandler(
    Frames.Events.FRAME_VALIDATION_CHANGED,
    onValidationChanged
  );

  function onValidationChanged (event) {
    var element = event.element;

    if (event.isValid || event.isEmpty) {
      clearErrorMessage(element);
    } else {
      setErrorMessage(element);
    }
  }

  function clearErrorMessage (el) {
    $(".error-message-" + el).remove();
  }

  function setErrorMessage (el) {
    var divText = "<div class=\"alert alert-danger ihjoz-alert ihjoz-alert-checkout error-message-" + el + "\">" + errors[el] + "</div>";
    $(divText).insertBefore(".online-payment-form");
  }

  Frames.addEventHandler(
    Frames.Events.CARD_VALIDATION_CHANGED,
    function (error) {
      payButton.disabled = !Frames.isCardValid();
    }
  );

  Frames.addEventHandler(
    Frames.Events.CARD_TOKENIZED,
    function (event) {
      payButton.disabled = !Frames.isCardValid();

      if (!payButton.disabled) {
        checkoutEnablePayButton();
      }
    }
  );

  Frames.addEventHandler(
    Frames.Events.CARD_TOKENIZATION_FAILED,
    onCardTokenizationFailed
  );

  function onCardTokenizationFailed (error) {
    Frames.enableSubmitForm();
  }

  payButton.addEventListener("click", function (event) {
    form.action = "https://merchant.com/charge-card";
    event.preventDefault();
    Frames.enableSubmitForm();
    checkoutDisablePayButton();
    Frames.submitCard()
      .then(function (data) {
        Frames.addCardToken(form, data.token);
        submitCheckoutPayment(data.token, component, data);
      })
      .catch(function (error) {
      // handle error
      });
  });
};

var checkoutDisablePayButton = function () {
  $(".payment-spinner").css("display", "inline-block");
  $(".demo-icon.icon-lock").hide();
  $("#checkoutPayButton").prop("disabled", true);
};

var checkoutEnablePayButton = function () {
  $(".payment-spinner").hide();
  $(".demo-icon.icon-lock").css("display", "inline-block");
};
  
function submitCheckoutPayment (token, component, data) {
  var data = {
    expiry_month: data["expiry_month"],
    expiry_year: data["expiry_year"],
    last4: data["last4"]
  };
  component.submitCheckoutPayment(data);
}

export default {
  name: "CheckoutPaymentForm",

  props: {
    invoiceId: { type: Number },
    paymentMethodId: { type: Number },
    checkoutPaymentMethod: { type: Object }
  },

  mounted () {
    this.loadCheckoutPaymentForm();
  },

  methods: {
    loadCheckoutPaymentForm () {
      if (this.checkoutPaymentMethod) {
        let vueComponentObject = this;
        let checkoutScript = document.createElement("script");
        checkoutScript.setAttribute("src", "https://cdn.checkout.com/js/framesv2.min.js");
        document.head.appendChild(checkoutScript);
        checkoutScript.addEventListener("load", function () {
          if (vueComponentObject.checkoutPaymentMethod) {
            loadCheckoutPayment(vueComponentObject, vueComponentObject.checkoutPaymentMethod.key);
          }
        });
      }
    },

    async submitCheckoutPayment (data) {
      let response = await PaymentStore.processPayment(this.invoiceId, data, this.paymentMethodId);
      if (response.success) {
        window.location.href = response.threeds_url;
      } else {
        this.handleResponseInplace(response);
      }
    }
  }
};
</script>
